<template>
    <div v-if="subjectId <= 0" id="chart">
    </div>
    <div v-else id="chart-by-subject">
    </div>
</template>
<script>

import ApexCharts from 'apexcharts'
import { getListExcerice } from './../../_api/lessonClassSchoolUserServices';
import { getAllTypeFilter } from './../../_api/'

export default {
    name: 'ChartAveragePoint',
    components: { ApexCharts },
    props: {
        classId: {
            type: Number,
            default: 0
        },
        subjectId: {
            type: Number,
            default: 0
        },
        keyword: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            listData: [],
            listDataSubject: [],
            lstSubjectName: [],
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
                subjectId: 0,
                classId: 0,
            },
            options: {
                series: [{
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }],
                chart: {
                    type: 'bar',
                    height: 'auto'
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                        dataLabels: {
                            position: 'center', // top, center, bottom
                        },
                    },
                },
                xaxis: {
                    title: {
                        text: 'Điểm số'
                    },
                    tickAmount: 10,
                    min: 0,
                    max: 10,
                    categories: [],
                },
                yaxis: {
                    tickAmount: 10,
                    min: 0,
                    max: 50,
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                },
                colors: ['#145aa5'],
                noData: {
                    text: 'Đang tải dữ liệu biểu đồ...'
                },
            },
        }
    },
    watch: {
        'classId': 'getAll',
        'options.series': 'updateChart',
        'listData': 'getListData',
        'subjectId': 'getListExerciseBySubjectId',
        'keyword': 'getListExerciseBySubjectId',
    },
    mounted() {
        if (this.classId > 0) {
            this.getAll()
        }
    },
    methods:{
        formatNumber(value){
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(0);
        },
        renderChart() {
            if (this.options.series.length > 0) {
                var chartElement = document.querySelector("#chart");
                if (this.subjectId > 0) {
                    chartElement = document.querySelector("#chart-by-subject");
                }
                if (chartElement != null) {
                    chartElement.innerHTML = ''
                    var chart = new ApexCharts(chartElement, this.options);
                    chart.render();
                }
            }
        },
        updateChart() {
            if (this.options.xaxis.categories.length > 0) this.renderChart()
        },
        getListData() {
            if (this.subjectId <= 0) {
                this.getListAveragePoint()
            }
            else {
                this.getListPoint()
            }
        },
        getListAveragePoint() {
            if (this.listData.length > 0) {
                let seriesData = []
                //Tính điểm trung bình các môn
                for (let i = 0; i < this.listDataSubject.length; i++) {
                    const element = this.listDataSubject[i];
                    let sum = 0;
                    let lstBySubject = this.listData.filter(x => x.subjectId == element.value) || [];
                    if (lstBySubject.length > 0) {
                        let lstExerciseHasPoint = lstBySubject.filter(x => !isNaN(x.point * 1) && typeof (x.point * 1) == 'number' && x.point * 1 <= 10) || []
                        let numExcercise = lstExerciseHasPoint.length
                        //tính tổng điểm tất các các bài kiểm tra của 1 môn học
                        sum = lstExerciseHasPoint.map(x => (x.point * 1).toFixed(2) * 1).reduce((accumulator, currentValue) => {
                            return accumulator + currentValue
                        }, 0);
                        //tính điểm trung bình của 1 môn học = tổng điểm / tổng số bài kiểm tra đã có điểm
                        let average = (sum / numExcercise).toFixed(2) * 1
                        if (average > 10) average = 10
                        seriesData.push(average)
                    }
                    else {
                        seriesData.push(0)
                    }
                }
                this.options.series = [{
                    data: seriesData
                }]
            }
            else {
                let seriesData = []
                for (let i = 0; i < this.listDataSubject.length; i++) { 
                    seriesData.push(0)
                }
                this.options.series = [{
                    data: seriesData
                }]
            }
        },
        getListPoint() {
            if (this.listData.length > 0) {
                let seriesData = []
                //Tính số bài đạt điểm từ 0 đến 10 của học sinh
                for (let point = 0; point <= 10; point++) {
                    let count = this.listData.filter(x => this.formatNumber(x.point * 1) * 1 == point).length
                    seriesData.push(count);
                }
                this.options.series = [{
                    data: seriesData
                }]
            }
            else {
                let seriesData = [0,0,0,0,0,0,0,0,0,0,0]
                this.options.series = [{
                    data: seriesData
                }]
            }
        },
        getAll() {
            this.getListDataSubject()
            this.getListExerciseBySubjectId()
        },
        getListDataSubject() {
            getAllTypeFilter({ classId: this.classId }).then(res => {
                if (res && res.data && !res.errors) {
                    this.listDataSubject = []
                    this.lstSubjectName = []
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        this.listDataSubject.push({ value: item.subjectId, text: item.name })
                        // Lấy danh sách môn học của khối gán vào biểu đồ
                        this.lstSubjectName.push(item.name)
                    }
                    this.options.xaxis.categories = this.lstSubjectName
                    this.renderChart()
                }
            })
        },
        getListExerciseBySubjectId() {
            this.listData = []
            this.paramQueryData.subjectId = this.subjectId
            this.paramQueryData.keyword = this.keyword
            this.paramQueryData.classId = this.classId
            if (this.subjectId > 0) {
                this.options.plotOptions.bar.horizontal = false
                this.options.xaxis.categories = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
            }
            else {
                this.options.xaxis.categories = this.lstSubjectName
                this.options.plotOptions.bar.horizontal = true
            }
            getListExcerice(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listData.push({ 
                            'stt': i + 1,
                            'classSchoolId': this.classSchoolId,
                            'subjectId':item.subjectId, 
                            'subjectName':item.subjectName,
                            'lessonName':item.lessonName,
                            'completeRate': item.completeRate,
                            'point': item.point,
                            'completeDate': item.completeDate,
                        })
                    }
                    this.totalRecords = res.data.paging.totalRecords
                }
                if (this.listData.length == 0) {
                    this.updateChart()
                }
            })
        }

    }
}
</script>
<style lang="scss" scoped>

</style>